import { useState } from "react";
import { VISOR_MODULE_BREADCRUMB_ROOT } from "@/modules/workModuleCore";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";
import { PageHeader } from "./layoutChrome";
import api, { formatApiError, tokenStore } from "@/lib/api";
import { toast } from "sonner";

export default function RecuperacionAcceso() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && !user.password_recovery_only) {
    return <Navigate to="/" replace />;
  }
  if (!user) {
    return <Navigate to="/recuperacion-extravio" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 4) {
      toast.error("La contraseña debe tener al menos 4 caracteres");
      return;
    }
    if (pwd !== pwd2) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/password-recovery/complete", { new_password: pwd });
      if (data.access_token) {
        tokenStore.set(data.access_token, data.refresh_token, { remember: false });
      }
      const { data: me } = await api.get("/auth/me");
      setUser(me);
      toast.success(data.message || "Contraseña actualizada");
      navigate("/", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "No se pudo actualizar la contraseña");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Nueva contraseña de acceso"
        subtitle="Sesión temporal por código de extravío. Defina su clave y continúe al sistema."
        breadcrumb={[VISOR_MODULE_BREADCRUMB_ROOT, "Recuperación", "Nueva contraseña"]}
      />
      <div className="p-8 max-w-md">
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-sm p-6 space-y-4 shadow-sm">
          <div className="flex items-start gap-3 text-amber-900 bg-amber-50 border border-amber-200 rounded-sm p-3 text-xs leading-snug">
            <Lock className="w-5 h-5 shrink-0 mt-0.5" />
            <p>
              Cuenta: <strong className="font-mono">{user.email}</strong>
              {user.uses_remaining != null ? (
                <>
                  {" "}
                  · Accesos restantes del código: <strong>{user.uses_remaining}</strong>
                </>
              ) : null}
            </p>
          </div>
          <div>
            <Label className="text-xs">Nueva contraseña</Label>
            <Input
              type="password"
              className="mt-1 font-mono"
              value={pwd}
              onChange={(e) => setPwd(e.target.value.slice(0, 128))}
              required
              minLength={4}
            />
          </div>
          <div>
            <Label className="text-xs">Confirmar contraseña</Label>
            <Input
              type="password"
              className="mt-1 font-mono"
              value={pwd2}
              onChange={(e) => setPwd2(e.target.value.slice(0, 128))}
              required
              minLength={4}
            />
          </div>
          <Button type="submit" className="w-full bg-[#3DA873] h-10" disabled={busy}>
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Guardar y entrar al sistema
          </Button>
          <Button
            type="button"
            variant="ghost"
            className="w-full text-xs text-slate-500"
            onClick={() => logout().then(() => navigate("/login"))}
          >
            Cancelar y cerrar sesión
          </Button>
        </form>
      </div>
    </>
  );
}
